import React from "react";
import { useTranslation } from "react-i18next";
import miniLogo from "@/assets/logos/logo_no_bg.webp";

const LoadingFallback = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="flex items-center justify-center mb-4">
        <div className="relative">
          <div className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center shadow-lg animate-pulse">
            <img
              src={miniLogo}
              alt="Talentino Logo"
              className="w-10 h-10 animate-bounce"
              width={20}
              height={20}
            />
          </div>

          {/* Pulsing ring animation */}
          <div className="absolute inset-0 w-16 h-16 border-4 border-primary-200 border-t-primary rounded-full animate-spin" />

          {/* Outer glow effect */}
          <div className="absolute inset-0 w-16 h-16 border-2 border-primary-100 rounded-full animate-ping" />
        </div>
      </div>

   
    </div>
  );
};
export default LoadingFallback